import { writable } from 'svelte/store';

function create_associating_devices() {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('associating_devices ')) || {},
	);

	return {
		subscribe,
		set,
		update: (id) =>
			update((associating_devices) => {
				return { ...associating_devices, [id]: true };
			}),
		remove: (id) =>
			update((associating_devices) => {
				delete associating_devices[id];
				return associating_devices;
			}),
		reset: () => set({}),
	};
}

export const associating_devices = create_associating_devices();
associating_devices.subscribe((val) =>
	localStorage.setItem('associating_devices ', JSON.stringify(val)),
);
